var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgYoutube = function SvgYoutube(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.25,
    y: 1.25,
    width: 25.5,
    height: 25.5,
    rx: 5.75,
    stroke: "currentColor",
    fill: "none",
    strokeWidth: 2.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3907 16.2167V11.4065C13.9845 12.2101 15.2189 12.9863 16.6788 13.8231C15.4747 14.5386 13.9845 15.3414 12.3907 16.2167ZM21.2728 9.01424C20.9979 8.62616 20.5293 8.32408 20.0305 8.22406C18.5642 7.92574 9.41679 7.92489 7.95132 8.22406C7.55129 8.30441 7.19507 8.49863 6.88907 8.80038C5.59971 10.0826 6.00373 16.9586 6.31452 18.0724C6.44521 18.5545 6.61415 18.9022 6.82692 19.1304C7.10105 19.4322 7.47637 19.64 7.90749 19.7331C9.11476 20.0007 15.3344 20.1503 20.005 19.7733C20.4353 19.693 20.8162 19.4785 21.1166 19.1639C22.3087 17.8869 22.2275 10.6247 21.2728 9.01424Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgYoutube);
export default ForwardRef;